// ISSUES_FETCH_START and ISSUES_FETCH_END pertain to an entire batch-fetch operation:
export const ISSUES_FETCH_START = 'ISSUES_FETCH_START';
export const ISSUES_FETCH_END = 'ISSUES_FETCH_END'; // not a promise-based action payload, so it's not "_FULFILLED" :
export const ISSUES_COLLECTION_RESET = 'ISSUES_COLLECTION_RESET';
export const ISSUES_FETCH_LOADING_START = 'ISSUES_FETCH_LOADING_START';
export const ISSUES_FETCH_API = 'ISSUES_FETCH_API';
export const ISSUES_FETCH_API_PENDING = 'ISSUES_FETCH_API_PENDING';
export const ISSUES_FETCH_API_FULFILLED = 'ISSUES_FETCH_API_FULFILLED';
export const ISSUES_FETCH_API_REJECTED = 'ISSUES_FETCH_API_REJECTED';
export const ISSUES_FETCH_PAYLOAD_INJECT = 'ISSUES_FETCH_PAYLOAD_INJECT';
export const ISSUES_FETCH_REPORT_START = 'ISSUES_FETCH_REPORT_START';
export const ISSUES_FETCH_REPORT_API = 'ISSUES_FETCH_REPORT_API';
export const ISSUES_FETCH_REPORT_API_FULFILLED = 'ISSUES_FETCH_REPORT_API_FULFILLED';
export const ISSUES_FETCH_REPORT_API_REJECTED = 'ISSUES_FETCH_REPORT_API_REJECTED';
export const ISSUE_INSTANCE_FETCH_START = 'ISSUE_INSTANCE_FETCH_START';
export const ISSUE_INSTANCE_FETCH_API = 'ISSUE_INSTANCE_FETCH_API';
export const ISSUE_INSTANCE_FETCH_API_PENDING = 'ISSUE_INSTANCE_FETCH_API_PENDING';
export const ISSUE_INSTANCE_FETCH_API_FULFILLED = 'ISSUE_INSTANCE_FETCH_API_FULFILLED';
export const ISSUE_INSTANCE_FETCH_API_REJECTED = 'ISSUE_INSTANCE_FETCH_API_REJECTED';
export const ISSUE_INSTANCE_FETCH_PAYLOAD_INJECT = 'ISSUE_INSTANCE_FETCH_PAYLOAD_INJECT';
export const RFI_CREATE_START = 'RFI_CREATE_START';
export const RFI_CREATE_API = 'RFI_CREATE_API';
export const RFI_CREATE_API_PENDING = 'RFI_CREATE_API_PENDING';
export const RFI_CREATE_API_FULFILLED = 'RFI_CREATE_API_FULFILLED';
export const RFI_CREATE_API_REJECTED = 'RFI_CREATE_API_REJECTED';
export const RFI_UPDATE_START = 'RFI_UPDATE_START';
export const RFI_UPDATE_API = 'RFI_UPDATE_API';
export const RFI_UPDATE_API_PENDING = 'RFI_UPDATE_API_PENDING';
export const RFI_UPDATE_API_FULFILLED = 'RFI_UPDATE_API_FULFILLED';
export const RFI_UPDATE_API_REJECTED = 'RFI_UPDATE_API_REJECTED';
export const REMOVE_ISSUE_FROM_COLLECTION = 'REMOVE_ISSUE_FROM_COLLECTION';
export const CHANNEL_ITEMS_FETCH_START = 'CHANNEL_ITEMS_FETCH_START';
export const CHANNEL_ITEMS_FETCH_API = 'CHANNEL_ITEMS_FETCH_API';
export const CHANNEL_ITEMS_FETCH_API_PENDING = 'CHANNEL_ITEMS_FETCH_API_PENDING';
export const CHANNEL_ITEMS_FETCH_API_FULFILLED = 'CHANNEL_ITEMS_FETCH_API_FULFILLED';
export const CHANNEL_ITEMS_FETCH_API_REJECTED = 'CHANNEL_ITEMS_FETCH_API_REJECTED';
export const ATTACHMENTS_FETCH_START = 'ATTACHMENTS_FETCH_START';
export const ATTACHMENTS_FETCH_API = 'ATTACHMENTS_FETCH_API';
export const ATTACHMENTS_FETCH_API_FULFILLED = 'ATTACHMENTS_FETCH_API_FULFILLED';
export const ATTACHMENTS_FETCH_API_REJECTED = 'ATTACHMENTS_FETCH_API_REJECTED';
export const COMMENT_CREATE_START = 'COMMENT_CREATE_START';
export const COMMENT_CREATE_API = 'COMMENT_CREATE_API';
export const COMMENT_CREATE_API_PENDING = 'COMMENT_CREATE_API_PENDING';
export const COMMENT_CREATE_API_FULFILLED = 'COMMENT_CREATE_API_FULFILLED';
export const COMMENT_CREATE_API_REJECTED = 'COMMENT_CREATE_API_REJECTED';
export const PREVIEW_ISSUE_ID_SET = 'PREVIEW_ISSUE_ID_SET';
export const SHOW_NEW_ISSUE_MODAL = 'SHOW_NEW_ISSUE_MODAL';
export const ISSUES_FETCH_SEARCH_START = 'ISSUES_FETCH_SEARCH_START';
export const ISSUES_FETCH_SEARCH_API = 'ISSUES_FETCH_SEARCH_API';
export const ISSUES_FETCH_SEARCH_API_FULFILLED = 'ISSUES_FETCH_SEARCH_API_FULFILLED';
export const ISSUES_CLEAR_SEARCH = 'ISSUES_CLEAR_SEARCH';
export const SET_PUSHPIN_VISIBILITY_POPUP = 'SET_PUSHPIN_VISIBILITY_POPUP';
export const TOGGLE_PUSHPIN_VISIBILITY = 'TOGGLE_PUSHPIN_VISIBILITY';
export const TOGGLE_PUSHPIN_VISIBILITY_SUCCESS = 'TOGGLE_PUSHPIN_VISIBILITY_SUCCESS';
export const TOGGLE_PUSHPIN_VISIBILITY_FAIL = 'TOGGLE_PUSHPIN_VISIBILITY_FAIL';
export const SET_DELETE_PUSHPIN_POPUP = 'SET_DELETE_PUSHPIN_POPUP';
export const DELETE_PUSHPIN = 'DELETE_PUSHPIN';
export const DELETE_PUSHPIN_SUCCESS = 'DELETE_PUSHPIN_SUCCESS';
export const DELETE_PUSHPIN_FAIL = 'DELETE_PUSHPIN_FAIL';
export const FETCH_RFI_CUSTOM_IDENTIFIER_START = 'FETCH_RFI_CUSTOM_IDENTIFIER_START';
export const FETCH_RFI_CUSTOM_IDENTIFIER_API = 'FETCH_RFI_CUSTOM_IDENTIFIER_API';
export const FETCH_RFI_CUSTOM_IDENTIFIER_API_FULFILLED =
  'FETCH_RFI_CUSTOM_IDENTIFIER_API_FULFILLED';
export const FETCH_RFI_CUSTOM_IDENTIFIER_API_REJECTED = 'FETCH_RFI_CUSTOM_IDENTIFIER_API_REJECTED';
export const VALIDATE_RFI_CUSTOM_IDENTIFIER_START = 'VALIDATE_RFI_CUSTOM_IDENTIFIER_START';
export const VALIDATE_RFI_CUSTOM_IDENTIFIER_API = 'VALIDATE_RFI_CUSTOM_IDENTIFIER_API';
export const VALIDATE_RFI_CUSTOM_IDENTIFIER_API_FULFILLED =
  'VALIDATE_RFI_CUSTOM_IDENTIFIER_API_FULFILLED';
export const VALIDATE_RFI_CUSTOM_IDENTIFIER_API_REJECTED =
  'VALIDATE_RFI_CUSTOM_IDENTIFIER_API_REJECTED';
export const RESET_RFI_CUSTOM_IDENTIFIER_VALIDITY = 'RESET_RFI_CUSTOM_IDENTIFIER_VALIDITY';
export const UPDATE_RFI_CUSTOM_IDENTIFIER_ANALYTICS_NEXT_SUGGESTION_CLICKED =
  'UPDATE_RFI_CUSTOM_IDENTIFIER_ANALYTICS_NEXT_SUGGESTION_CLICKED';
export const UPDATE_RFI_CUSTOM_IDENTIFIER_ANALYTICS_IS_EDITED =
  'UPDATE_RFI_CUSTOM_IDENTIFIER_ANALYTICS_IS_EDITED';

export const FETCH_RFIS_FOR_CSV_REPORT = 'FETCH_RFIS_FOR_CSV_REPORT';
export const FETCH_RFIS_FOR_CSV_REPORT_FULFILLED = 'FETCH_RFIS_FOR_CSV_REPORT_FULFILLED';
export const FETCH_RFIS_FOR_CSV_REPORT_REJECTED = 'FETCH_RFIS_FOR_CSV_REPORT_REJECTED';
export const RFIS_CSV_REPORT_DOWNLOADED = 'RFIS_CSV_REPORT_DOWNLOADED';
export const CREATE_RFI_PROCESS_START = 'CREATE_RFI_PROCESS_START';
export const CREATE_RFI_PROCESS_END = 'CREATE_RFI_PROCESS_END';
export const REMOVE_RFI_FROM_LIST = 'REMOVE_RFI_FROM_LIST';

export const ADD_LINKED_ENTITIES = 'ADD_LINKED_ENTITIES';
export const ADD_LINKED_ENTITIES_API = 'ADD_LINKED_ENTITIES_API';
export const ADD_LINKED_ENTITIES_API_FULFILLED = 'ADD_LINKED_ENTITIES_API_FULFILLED';
export const ADD_LINKED_ENTITIES_API_REJECTED = 'ADD_LINKED_ENTITIES_API_REJECTED';
export const REMOVE_LINKED_ENTITIES = 'REMOVE_LINKED_ENTITIES';
export const REMOVE_LINKED_ENTITIES_API = 'REMOVE_LINKED_ENTITIES_API';
export const REMOVE_LINKED_ENTITIES_API_FULFILLED = 'REMOVE_LINKED_ENTITIES_API_FULFILLED';
export const REMOVE_LINKED_ENTITIES_API_REJECTED = 'REMOVE_LINKED_ENTITIES_API_REJECTED';

export const VIRTUAL_FOLDER_CREATE_START = 'VIRTUAL_FOLDER_CREATE_START';
export const VIRTUAL_FOLDER_CREATE_API = 'VIRTUAL_FOLDER_CREATE_API';
export const VIRTUAL_FOLDER_CREATE_API_FULFILLED = 'VIRTUAL_FOLDER_CREATE_API_FULFILLED';
export const VIRTUAL_FOLDER_CREATE_API_REJECTED = 'VIRTUAL_FOLDER_CREATE_API_REJECTED';

export const FETCH_RFI_ASYNC_ATTRIBUTES_START = 'FETCH_RFI_ASYNC_ATTRIBUTES_START';

export const fetchIssuesAction = (payload = {}, meta = {}) => {
  return {
    type: ISSUES_FETCH_START,
    meta,
    payload,
  };
};

export const fetchIssuesReport = (payload, meta = {}) => {
  return {
    type: ISSUES_FETCH_REPORT_START,
    meta,
    payload,
  };
};

export const fetchIssueInstanceAction = (issueId, isDeepLinking) => {
  return {
    type: ISSUE_INSTANCE_FETCH_START,
    payload: issueId,
    meta: { isDeepLinking },
  };
};

export const createIssueAction = (
  issueAttributes,
  {
    transitionsFlow,
    transitionAttributes,
    onSuccess,
    onError,
    isDeepLinking,
    customIdentifier,
  } = {}
) => {
  return {
    type: RFI_CREATE_START,
    meta: {
      transitionsFlow,
      transitionAttributes,
      onSuccess,
      onError,
      isDeepLinking,
      customIdentifier,
    },
    payload: issueAttributes,
  };
};

export const removeIssueFromCollectionAction = (id) => {
  return {
    type: REMOVE_ISSUE_FROM_COLLECTION,
    payload: id,
  };
};

export const updateIssueAction = (issue, attributes, meta = {}) => {
  return {
    type: RFI_UPDATE_START,
    meta,
    payload: { issue, attributes },
  };
};

export const fetchChannelItemsAction = (issueId) => {
  return {
    type: CHANNEL_ITEMS_FETCH_START,
    payload: issueId,
  };
};

export const fetchAttachmentsAction = (issueId) => {
  return {
    type: ATTACHMENTS_FETCH_START,
    payload: issueId,
  };
};

export const createCommentAction = (issueId, comment, resolve, reject) => {
  return {
    type: COMMENT_CREATE_START,
    meta: {
      id: issueId,
      resolve,
      reject,
    },
    payload: comment,
  };
};

export const setPreviewIssueIdAction = (issueId) => {
  return {
    type: PREVIEW_ISSUE_ID_SET,
    payload: issueId,
  };
};

export const showNewIssueModalAction = (visible) => {
  return {
    type: SHOW_NEW_ISSUE_MODAL,
    payload: visible,
  };
};

export const getSearchResultsAction = (search) => {
  return {
    type: ISSUES_FETCH_SEARCH_START,
    payload: search,
  };
};

export const clearSearchResultsAction = () => {
  return {
    type: ISSUES_CLEAR_SEARCH,
  };
};

export const setIsShowingPushpinVisibilityPopUp = (isVisible) => {
  return {
    type: SET_PUSHPIN_VISIBILITY_POPUP,
    payload: isVisible,
  };
};

export const setIsShowingDeletePushpinPopUp = (isVisible) => {
  return {
    type: SET_DELETE_PUSHPIN_POPUP,
    payload: isVisible,
  };
};

export const togglePushpinVisibility = (issue) => {
  return {
    type: TOGGLE_PUSHPIN_VISIBILITY,
    payload: issue,
  };
};

export const deletePushpin = (issue) => {
  return {
    type: DELETE_PUSHPIN,
    payload: issue,
  };
};

export const deletePushpinSuccess = (pushpinId) => {
  return {
    type: DELETE_PUSHPIN_SUCCESS,
    payload: {
      pushpinId,
    },
  };
};

export const deletePushpinFail = () => {
  return {
    type: DELETE_PUSHPIN_FAIL,
  };
};

export const issuesCollectionReset = (payload = {}) => {
  return {
    type: ISSUES_COLLECTION_RESET,
    payload,
  };
};

export const validateRfiCustomIdentifierAction = (payload = {}, meta = {}) => {
  return {
    type: VALIDATE_RFI_CUSTOM_IDENTIFIER_START,
    meta,
    payload,
  };
};

export const getRfiCustomIdentifierAction = (meta = {}) => {
  return {
    type: FETCH_RFI_CUSTOM_IDENTIFIER_START,
    meta,
  };
};

export const resetRfiCustomIdentifierValidityAction = () => {
  return {
    type: RESET_RFI_CUSTOM_IDENTIFIER_VALIDITY,
  };
};

export const updateRfiCustomIdentifierAnalyticsIsEditedAction = () => {
  return {
    type: UPDATE_RFI_CUSTOM_IDENTIFIER_ANALYTICS_IS_EDITED,
  };
};

export const updateRfiCustomIdentifierAnalyticsNextSuggestionClickedAction = () => {
  return {
    type: UPDATE_RFI_CUSTOM_IDENTIFIER_ANALYTICS_NEXT_SUGGESTION_CLICKED,
  };
};

export const rfisCsvReportDownloaded = () => {
  return {
    type: RFIS_CSV_REPORT_DOWNLOADED,
  };
};

export const createRfiProcessStart = () => {
  return {
    type: CREATE_RFI_PROCESS_START,
  };
};

export const createRfiProcessEnd = () => {
  return {
    type: CREATE_RFI_PROCESS_END,
  };
};

export const removeRfiFromList = (rfiId) => {
  return {
    type: REMOVE_RFI_FROM_LIST,
    payload: {
      rfiId,
    },
  };
};

export const addLinkedEntitiesAction = (issue, entities, onSuccess, onFailure) => {
  return {
    type: ADD_LINKED_ENTITIES,
    payload: {
      issue,
      entities,
      onSuccess,
      onFailure,
    },
  };
};

export const removeLinkedEntityAction = (issue, item, onSuccess, onFailure) => {
  return {
    type: REMOVE_LINKED_ENTITIES,
    payload: {
      issue,
      item,
      onSuccess,
      onFailure,
    },
  };
};

export const injectRfiAttributes = (attributes, id) => ({
  type: ISSUE_INSTANCE_FETCH_PAYLOAD_INJECT,
  payload: attributes,
  meta: {
    id,
  },
});

export const fetchRfiAsyncAttributes = (id, retryNumber = 0) => ({
  type: FETCH_RFI_ASYNC_ATTRIBUTES_START,
  payload: {
    id,
  },
  meta: {
    retryNumber,
  },
});

export const createVirtualFolderAction = (resolve, reject) => {
  return {
    type: VIRTUAL_FOLDER_CREATE_START,
    meta: {
      resolve,
      reject,
    },
  };
};
